module.exports = __webpack_public_path__ + "static/img/btn-bg-yellow.a9ac64c5.png";